import { OverflowMenu } from "lib-core"

export default OverflowMenu